<template>
  <div class="zu-ct-warp zu-ct-table" ref="table" :class="{'is-radius': radius}" :style="tableCss">
    <table cellspacing="0" cellpadding="0" border="0" :class="['zu-ct-table-inner', !data.length && 'is-no-data']">
      <colgroup>
        <col v-for="(col, idx) in colList" :key="idx" :width="col" />
      </colgroup>
      <thead class="zu-ct-header" v-if="config.length" :style="headerStyle" :align="align" :valign="valign">
        <tr class="zu-ct-row">
          <th class="zu-ct-cell" v-for="(item, idx) in config" :key="idx">
            <template v-if="Array.isArray(item.label)">
              <div class="header-custom" ref="custom" :style="{width: `${colList[idx]-1}px`}">
                <div class="header-left">{{  item.label[0] }}</div>
                <div class="header-right">{{  item.label[1] }}</div>
                <div class="header-line" :style="lineCss"></div>
              </div>
            </template>
            <div class="zu-ct-text" :style="{width: `${colList[idx]-1}px`}" v-else>
              <span class="zu-ct-span">{{ item.label }}</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="zu-ct-body" :class="[!config.length && 'is-no-header']" :align="align" :valign="valign">
        <tr :class="['zu-ct-row', { active: item.active } ]" v-for="(item, index) in data" :key="index">
          <template v-for="(child, idx) in config">
            <td v-if="item.hide !== child.prop && item.secondHide !== child.prop" class="zu-ct-cell" :class="[['other'].includes(child.type) && 'other-cell', ['title', 'custom'].includes(child.type) && 'font-weight-cell', ['title', 'custom'].includes(child.type) && 'title-cell']" v-bind="getRowCol(item, child.prop)">
              <div class="zu-ct-text" :style="{width: `${colList[idx+(item.hide ? 1 : 0)]-1}px`}" v-ellipsis-tooltip>
                <span class="zu-ct-span">
                  <template v-if="child.type === 'index'">{{ index + 1 }}</template>
                  <template v-else>
                    <span v-if="child.prop === 'action'" class="c-p" :style="{ color: item.action?.color }" @click="handleAction(item)">{{ item.action?.text }}</span>
                    <template v-else>{{ item[child.prop] }}</template>
                  </template>
                </span>
              </div>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
    <div class="zu-ct-empty" v-if="!config.length || !data.length">
      <slot name="empty">
        <zu-empty :text="emptyText" :src="emptySrc"></zu-empty>
      </slot>
    </div>
    <div class="zu-ct-footer"></div>
  </div>
</template>

<script>
import ZuEmpty from '@/components/common/ZuEmpty.vue'
import { preciseAdd, preciseSubtract, preciseDivide, preciseMultiply, getAverage } from '@/utils'
// config  type类型说明  custom  title  other  index
export default {
  props: {
    data: {type: Array, default: () => [] },
    config: {type: Array, default: () => [] },
    border: {type: Boolean, default: true },
    type: {type: String, default: 'blue' },
    emptyText: {type: String, default: '暂无数据' },
    emptySrc: {type: String, default: '/img/data-d.png' },
    align: {type: String, default: 'center' },
    valign: {type: String, default: 'middle' },
    radius: {type: Boolean, default: true },
    headerColor: {type: String, default: '' },
    headerBgColor: {type: String, default: '' },
    headerLineColor: {type: String, default: '' },
    headerStyle: {type: Object, default: () => ({}) },
    color: {type: String, default: '' },
    bgColor: {type: String, default: '' },
    titleBgColor: {type: String, default: '' },
    borderColor: {type: String, default: '' },
    customStyle: {type: Object, default: () => ({}) },
  },
  components: { ZuEmpty },
  directives: {
    ellipsisTooltip: {
      bind(el) {
        // 创建tooltip元素
        const tooltip = document.createElement('div');
        tooltip.className = 'zu-tooltip';
        tooltip.style.display = 'none';
        // 创建箭头元素
        const arrow = document.createElement('div');
        arrow.className = 'zu-tooltip-arrow zu-tooltip-arrow-top';
        tooltip.appendChild(arrow);
        document.body.appendChild(tooltip);
        // 存储tooltip引用
        el._tooltip = tooltip;
        // 子元素
        const child = el.children[0];
        // 鼠标进入事件
        el.addEventListener('mouseenter', function(e) {
          // 检查是否文本溢出
          if (el.offsetWidth < child.offsetWidth) {
            tooltip.innerHTML = child.textContent + arrow.outerHTML;
            tooltip.style.display = 'block';
            // 定位tooltip
            const rect = el.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            let top = rect.top - tooltipRect.height - 8;
            let left = rect.left + (rect.width - tooltipRect.width) / 2;
            // 防止tooltip超出屏幕
            if (top < 5) top = rect.bottom + 8;
            if (left < 5) left = 5;
            if (left + tooltipRect.width > window.innerWidth - 5) {
              left = window.innerWidth - tooltipRect.width - 5;
            }
            tooltip.style.top = top + window.scrollY + 'px';
            tooltip.style.left = left + window.scrollX + 'px';
          }
        })
        // 鼠标离开事件
        el.addEventListener('mouseleave', function() {
          tooltip.style.display = 'none';
        })
      },
      unbind(el) {
        // 清理工作
        if (el._tooltip) {
          document.body.removeChild(el._tooltip);
          delete el._tooltip;
        }
      }
    }
  },
  computed: {
    tableCss() {
      const justifyContent = {
        center: 'center',
        left: 'flex-start',
        right: 'flex-end'
      }
      const textMap = {
        center: 'center',
        left: 'left',
        right: 'right'
      }
      const type = this.getType()
      const objMap = {
        blue: {
          headerColor: '#ffffff',
          headerBgColor: '#6B9BFC',
          headerLineColor: '#86B0FF',
          color: '#333333',
          bgColor: '#FFFFFF',
          titleBgColor: '#E1EEFF',
          borderColor: '#7BB2F4'
        },
        orange: {
          headerColor: '#ffffff',
          headerBgColor: '#FC996B',
          headerLineColor: '#F6C379',
          color: '#333333',
          bgColor: '#FFF3E2',
          titleBgColor: '#FFDCBB',
          borderColor: '#F69132'
        },
        gray: {
          headerColor: '#333333',
          headerBgColor: '#F6F9FF',
          headerLineColor: '#DBDDE4',
          color: '#333333',
          bgColor: '#FFFFFF',
          titleBgColor: '#F6F9FF',
          borderColor: '#DBDDE4'
        }
      }
      const obj1 = objMap[type]
      const obj2 = {}
      if (this.headerColor) obj2.headerColor = this.headerColor
      if (this.headerBgColor) obj2.headerBgColor = this.headerBgColor
      if (this.headerLineColor) obj2.headerLineColor = this.headerLineColor
      if (this.color) obj2.color = this.color
      if (this.bgColor) obj2.bgColor = this.bgColor
      if (this.titleBgColor) obj2.titleBgColor = this.titleBgColor
      if (this.borderColor) obj2.borderColor = this.borderColor
      const obj = Object.assign({}, obj1, obj2)
      return {
        '--zu-justify': justifyContent[this.align] || 'center',
        '--zu-align': textMap[this.align] || 'center',
        '--zu-header-line': obj.headerLineColor,
        '--zu-header-bg': obj.headerBgColor,
        '--zu-header-color': obj.headerColor,
        '--zu-border-color': obj.borderColor,
        '--zu-body-bg': obj.bgColor,
        '--zu-body-title-bg': obj.titleBgColor,
        '--zu-body-color': obj.color,
        ...this.customStyle
      }
    },
    lineCss() {
      let m = this.colList[0] || this.width
      const deg = (this.height / m) * 180 / Math.PI
      const len = Math.sqrt(Math.pow(m, 2) + Math.pow(this.height, 2))
      return {
        height: `${len}px`,
        transform: `rotate(${deg - 90}deg)`
      }
    },
    colList() {
      let w = this.clientWidth
      const list1 = this.config.map(i => Number(i.width) || 0)
      const list2 = list1.filter(i => i)
      const sum = list2.reduce((a, b) => a + b, 0), len1 = list1.length, len2 = list2.length
      let arr = []
      if (sum > w) {
        const a1 = getAverage(w, len1)
        arr = new Array(len1).fill(a1[0])
        if (a1.length > 1) {
          arr.fill(a1[1],0,1)
        }
      } else {
        const d = (len1 - len2) || 1
        const v = w - sum - (this.border ? 1 : 0)
        const a1 = getAverage(v, d)
        let isA = a1.length === 2
        arr = list1.map(i => {
          if (i) return i
          if (isA) {
            isA = false
            return a1[1]
          }
          return a1[0]
        })
      }
      return arr
    }
  },
  data() {
    return {
      height: 0,
      width: 0,
      clientWidth: 0
    }
  },
  methods: {
    resize() {
      const table = this.$refs.table
      if (!table) return
      this.clientWidth = table.clientWidth || 0
      const custom = table.querySelector('.header-custom')
      if (!custom) return
      this.height = custom.clientHeight || 0
      this.width = custom.clientWidth || 0
    },
    getType() {
      const typeMap = { blue: 'blue', gray: 'gray', orange: 'orange' }
      const type = typeMap[this.type] || 'blue'
      return type
    },
    getRowCol(row, key) {
      const { rowspan, colspan, rowKey, colKey, secondRowSpan, secondRowKey, secondColSpan, secondColKey } = row
      const obj = {}
      if (rowKey === key) obj.rowspan = rowspan
      if (colKey === key) obj.colspan = colspan
      if (secondRowKey === key) obj.rowspan = secondRowSpan
      if (secondColKey === key) obj.colspan = secondColSpan
      return obj
    },
    handleAction(row) {
      this.$emit('action', row)
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
.zu-table {
  &.el-table {
    color: #333;
    border-color: var(--zu-border);
    &::before {
      background-color: var(--zu-border);
    }
    &--border, &--group {
      border-color: var(--zu-border);
      &::after {
        background-color: var(--zu-border);
      }
    }
    &__cell {
      &td, &th {
        border-color: var(--zu-border);
      }
    }
  }
  td.el-table__cell, th.el-table__cell.is-leaf {
    border-color: var(--zu-border);
  }
  .header {
    &-custom {
      &.el-table__cell {
        padding: 0px !important;
        background-color: var(--zu-bg);
      }
    }
    &-inner {
      height: 50px;
    }
    &-left {
      position: absolute;
      left: 4px;
      bottom: 6px;
    }
    &-right {
      position: absolute;
      right: 4px;
      top: 6px;
    }
    &-line {
      position: absolute;
      left: 0;
      top: 0;
      width: 1px;
      height: 200px;
      background-color: var(--zu-line);
      transform-origin: top;
      transform: rotate(-72.2deg); /*这里需要自己调整，(height / width ) * 180 / Math.PI */
    }
  }
}

</style>
